import * as React from 'react'
import { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { NextPage } from 'next'
import bg from '@images/priv.png'
import Layout from '@/components/layout'
import Image from 'next/image'
import styles from './index.module.scss'
import Head from 'next/head'
const PrivacyPolicy: NextPage<{
  context: any
}> = (props) => {
  return (
    <div>
      <Layout header={true} footer={true}>
        <Head>
          <title>Privacy Policy | TikTok Analytics | Shoplus</title>
          <meta name="keywords" content="TikTok analytics, influencer marketing" />
          <meta
            name="description"
            content="Read privacy policy of Shoplus-best TikTok analytics tool."
          />
        </Head>
        <div className={styles.priv}>
          <div className="defeaultContainer">
            <div className={styles.header}>
              <div className={styles.text}>
                <h1 className={styles.title}>Privacy Policy</h1>
                <h2 className={styles.tip}>
                  Learn more about how Shoplus collects and
                  <br />
                  uses data and your rights as a Shoplus user.
                </h2>
              </div>
              <div className={styles.img}>
                <Image src={bg} alt="Privacy Policy"></Image>
              </div>
              <div className={styles.bg}></div>
            </div>

            <div className={styles.sign}>May 1, 2022:</div>
            <div className={styles.content}>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>Overview</h3>
                <span className={styles['content-tip']}>
                  We pay attention to and are committed to protecting the privacy of our customers.
                  This Privacy Policy is meant to explain to you how we collect, use,share and
                  protect your personal information through our website at www.shoplus.net and our
                  advertising platform (“Advertising Service”). Please review this Privacy Policy
                  before using this Site or the Adverting Service.By using this Site or the Service,
                  you acknowledge that you have read this Privacy Policy and agree to be bound by
                  this Policy in respect of the information collected about you.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>
                  1. Information We Collect Through Our Services and Our Site
                </h3>
                <span className={styles['content-tip']}>
                  We may collect the personal information that you provide to us when you are
                  <br />
                  visiting our Site and using our Services, such as names, E-mail address,
                  <br />
                  telephone numbers, payment information, etc.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>2. Use of Information</h3>
                <span className={styles['content-tip']}>
                  We may use your personal information for the following purposes:
                  <div className="mb-[24px]"></div>
                  2.1 To provide our Site and Service; <br />
                  2.2 To contact you and respond to your requests and enquire;
                  <br />
                  2.3 To analyze and improve the Site and our Service;
                  {/* <br /> 2.4 To display ads that you may interested in. */}
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>
                  3. How We Share the Service Information and Site Information
                </h3>
                <span className={styles['content-tip']}>
                  3.1 We will not rent, sell or provide your personal information to any other
                  person or unrelated company without your consent. We may share or provide your
                  personal information: <br />
                  (a) To comply with the court order, laws, and regulations, requirements of
                  government, or other legal procedures;
                  <br /> (b) To protect our rights or the rights of others;
                  <br />
                  (c) For the needs of transactions such as sale, merger, restructuring, or
                  bankruptcy;
                  <div className="mb-12px"></div>
                  <br /> 3.2 To improve the quality of our Advertising Service, we may cooperate
                  with third parties, such as advertisers, publishers, and data tracking companies.
                  If we share your personal information with third parties, we will use
                  encryption,de-identification, and anonymization measures to keep your information
                  secure and we will require them to implement security measures for your personal
                  information. These third parties may collect your information while you are
                  visiting the Site and using our service. These third parties will be governed by
                  their privacy policies. We recommend that you read the privacy policies of such
                  third parties carefully.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>4. Cookies and Related Technology</h3>
                <span className={styles['content-tip']}>
                  In order to provide more convenient services, improve the quality of the Site
                  experiences, or tailor advertising, we may use Cookies or other
                  technology(collectively “Cookies”) to store and track information about you when
                  you are visiting the Site, such as device type, network connection type, the date
                  and time of your visit, etc., More about Cookies by visiting AboutCookies.org.If
                  you do not accept these Cookies, you can change your browser’s settings to delete
                  Cookies that have already been set and to not accept new Cookies. But if you
                  delete Cookies or do not accept them, you might not be able to use all of the
                  features we offer, you may not be able to store your preferences, and some of our
                  pages might not display properly.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>5. Your Information Rights</h3>
                <span className={styles['content-tip']}>
                  You have the right to restrict us to collect and use your personal
                  information.These may include the right:
                  <br />
                  5.1 To access to and request a copy of your personal information;
                  <br />
                  5.2 To request an update and correct your personal information;
                  <br />
                  5.3 To request the erasure of your personal information;
                  <br />
                  5.4 To restrict or object to the collection and use of your personal information;
                  <br />
                  {`5.5 To withdraw your consent at any time. The withdrawal of
                  consent shall not affect the lawfulness of processing based on
                  consent before its withdrawal.To exercise any of your rights,
                  please contact us by "Contacting Us". We may ask you to verify
                  your identity and act upon your requests in accordance with
                  applicable laws`}
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>
                  6. Applicable Provisions for EU residents
                </h3>
                <span className={styles['content-tip']}>
                  6.1 When you are located in the European Economic Area (EEA), you will have the
                  following additional rights:
                  <br />
                  (a) To ask for a copy of your personal information to be provided to them, or a
                  third party;
                  <br />
                  (b) To lodge a complaint about the processing of your personal information with
                  your local data protection authority in the EEA.
                  <br />
                  6.2 When you are located in the EEA, your personal information will be transferred
                  to recipients in countries located outside the EEA, which do not provide a similar
                  or adequate level of protection to that provided by countries in the EEA.You
                  hereby expressly consent to the transfer of your personal information to
                  recipients, as described in this Privacy Policy, which is located outside the
                  EEA.You may withdraw your consent at any time.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>7. Security of Information</h3>
                <span className={styles['content-tip']}>
                  We will implement appropriate physical, technical, and organizational security
                  measures to prevent the unauthorized reading, copying, modification, or deletion
                  of your information. The measures include but are not limited to:
                  <br />
                  7.1 For the information system that stores your personal information, we adopt
                  access review to prevent intrusion and anti-virus;
                  <br />
                  7.2 We will store de-identified information separately from information that can
                  be used to re-identify individuals to ensure that individuals are not
                  re-identified in subsequent processing of de-identified information;
                  <br />
                  {`7.3 We have established a relevant internal control system,
                  adopted the principle of minimum sufficient authorization for
                  staff who may have access to your personal information, kept
                  records of staff's handling of your personal information,
                  training its staff on knowledge, skills, and safety
                  responsibilities related to the protection of users' personal
                  information, and regularly conducted self-audits on the
                  protection of your personal information.`}
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>8. Protection of Children</h3>
                <span className={styles['content-tip']}>
                  We do not knowingly collect personal information about children under the ageof 13
                  (in EEA is under the age of 16). If a parent or guardian becomes aware that his or
                  her child has provided us with information without their consent, he or she should
                  promptly contact us and we take reasonable steps to ensure that such information
                  is deleted from our files.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>9. Information Retention</h3>
                <span className={styles['content-tip']}>
                  We may retain and use your information in a non-identifiable, aggregated format.
                  Your personal information is retained for no longer than is necessary to achieve
                  the purposes described in this privacy policy, to comply with the legal
                  obligations of the applicable law, to resolve disputes, and to enforce agreements.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>10. Changes to Privacy Policy</h3>
                <span className={styles['content-tip']}>
                  We will update and revise this Privacy Policy from time to time in order to
                  accommodate new technologies, industry practices, regulatory requirements, or for
                  other purposes. The most recent version of the Policy will be posted on the Site.
                  When we do so, we will revise the “Effective Date” at the top of this page.
                  <div className="mb-12px"></div>
                  Your continued visit Site or use of our Service will be deemed as acceptance of
                  the updated Privacy Policy.
                </span>
              </div>
              <div className={styles['content-setion']}>
                <h3 className={styles['content-title']}>11. Contact Us</h3>
                <span className={styles['content-tip']}>
                  If you have any question or comment about this Policy, please contact us via
                  【marketing@Shoplus.net】.
                  <br />
                  Feedly Digitial Limited,19h Maxgrand Plaza No.3 Tai Yau Street San Po Kong Kl.
                  <br />
                  Please make sure to include your name and subject matter in your email and we will
                  respond to you within 15 working days.
                </span>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context
  return {
    props: {
      ...(await serverSideTranslations(locale as string, ['home', 'common', 'nav', 'footer'])),
      context: {
        locale,
        req: {
          headers: context.req.headers
        }
      }
    }
  }
}
export default PrivacyPolicy
